import { Presenter } from '@d-id/types';

export const isNewPresenter = (presenter: Presenter) => {
    const maxDateBeingNew = new Date();
    maxDateBeingNew.setDate(new Date().getDate() - 30);

    return !!(presenter.created_at && new Date(presenter.created_at) > maxDateBeingNew && presenter.isDefault);
};
